import { instance } from './axiosConfig'
export default {
  async getUsersMe() {
    const url = '/users/me'
    const res = await instance.get(url)
    return res
  },

  async getUsersModels(userId) {
    const url = `/users/${userId}/models?type=INSPECT_REPAIR_ORDER,INSPECT,PROCESS,VIDEO`
    const res = await instance.get(url)
    return res
  }
}
